// ** React Imports
import { createContext, useEffect, useState } from 'react'

// ** Next Import
import { useNavigate } from 'react-router-dom'


// ** Axios
import axios from 'axios'

// ** Defaults
const defaultProvider = {
  uploadFilesResponse: null,
  getPendingRecord: null,
  getCompletedRecord: null,
  getHistoryRecord: null,
  getReportsRecord: null,
  completedRecord: null,
  historyRecord: null,
  reportRecord: null,
  uploadZipFilesResponse: null,
  loading: true,
  setPendingRecord: () => null,
  setCompletedRecord: () => null,
  setHistoryRecord: () => null,
  setReportRecord: () => null,
  setLoading: () => Boolean,
  postUserToken: () => Promise.resolve(),
  postUploadZipFiles: () => Promise.resolve(),
  postUploadExcelTrueClaim: () => Promise.resolve(),
}
const UploadContext = createContext(defaultProvider)

const UploadProvider = ({ children }) => {
  // ** States
  const [uploadFilesResponse, setUploadFilesResponse] = useState(defaultProvider.uploadFilesResponse)
  const [UploadZipFilesResponse, setUploadZipFilesResponse] = useState(defaultProvider.uploadZipFilesResponse)
  const [completedRecord, setCompletedRecord] = useState(defaultProvider.completedRecord)
  const [historyRecord, setHistoryRecord] = useState(defaultProvider.historyRecord)
  const [pendingRecord, setPendingRecord] = useState(defaultProvider.getPendingRecord)
  const [reportRecord, setReportRecord] = useState(defaultProvider.getPendingRecord)
  const [userToken, setUserToken] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  // ** Hooks
  const navigate = useNavigate()

  const postUserToken = async (files, errorCallback) => {
    setLoading(true)
    try {
      const response = await axios.post('https://api.trueselleroms.com/login', {
        // const response = await axios.post('http://localhost:8088/login', {
        email: "Demo@tsoms.com",
        password: "#@Yakuz@2023@#"
      })
      setUserToken(response.data.token)
      if (errorCallback) errorCallback({ status: 'success' })
    } catch (error) {
      setUserToken('')
      if (errorCallback) errorCallback({ status: 'error' })
      setTimeout(() => setError(''), 3000)
    } finally {
      setLoading(false)
    }
  }

  const checkUploadStatus = async (files, errorCallback) => {
    // console.log('postUploadFiles', files)
    setLoading(true)
    try {
      const response = await axios.post('http://localhost:8088/login', {
        email: "Demo@tsoms.com",
        password: "#@Yakuz@2023@#"
      })
      setUserToken(response.data.token)
      if (errorCallback) errorCallback({ status: 'success' })
    } catch (error) {
      setUserToken('')
      if (errorCallback) errorCallback({ status: 'error' })
      setTimeout(() => setError(''), 3000)
    } finally {
      setLoading(false)
    }
  }
  const postUploadZipFiles = async (files, errorCallback) => {
    if (userToken) {
      setLoading(true)
      // .post(`http://localhost:8088/user/upload-all`, { file: files }, {
      await axios
        .post(`https://api.trueselleroms.com/user/upload-all`, files, {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "multipart/form-data",
          }
        })
        .then(async response => {
          if (errorCallback) errorCallback({ status: 'success' })
          setLoading(false)
          // setUploadZipFilesResponse(response.data)
        })
        .catch((error) => {
          setUploadZipFilesResponse(null)
          setError(error.response)
          if (errorCallback) errorCallback({ status: 'error' })
          setTimeout(() => {
            setError('')
          }, 3000);

          setLoading(false)
        })
    } else {
      console.log('call in else')
      setLoading(false)
    }
  }

  const postUploadExcelTrueClaim = async (files, errorCallback) => {
    if (userToken) {
      setLoading(true)
      // .post(`http://localhost:8088/user/upload-all`, { file: files }, {
      await axios
        // .post(`http://localhost:5001/api/claims/upload-excel-trueclaim`, files, {
        .post(`http://103.160.106.215:5001/api/claims/upload-excel-trueclaim`, files, {
          headers: {
            Authorization: `Bearer ${userToken}`,
            "Content-Type": "multipart/form-data",
          }
        })
        .then(async response => {
          if (errorCallback) errorCallback({ status: 'success' })
          setLoading(false)
          // setUploadZipFilesResponse(response.data)
        })
        .catch((error) => {
          // setUploadZipFilesResponse(null)
          setError(error.response)
          if (errorCallback) errorCallback({ status: 'error' })
          setTimeout(() => {
            setError('')
          }, 3000);

          setLoading(false)
        })
    } else {
      console.log('call in else')
      setLoading(false)
    }
  }

  const postUploadFiles = async (payload) => {
    // console.log('postUploadFiles', files)
    let token = JSON.parse(localStorage.getItem("userData"))
    if (token) {
      setLoading(true)
      await axios
        .post(`${process.env.REACT_APP_BASE_URL}/gst-profile`, payload, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setUploadFilesResponse(response.data)
        })
        .catch((error) => {
          setUploadFilesResponse(null)
          if ((error.response && error.response.status === 403) || !token) {
            // localStorage.removeItem("userData")
            // navigate('/login')
          } else {
            setError('Something Went Wrong')
            setTimeout(() => {
              setError('')
            }, 3000);
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  const getPendingRecord = async (payload) => {
    // console.log('postUploadFiles', files)
    let token = JSON.parse(localStorage.getItem("userData"))
    if (token) {
      setLoading(true)
      await axios
        .get(`${process.env.REACT_APP_BASE_URL}/gst-profile`, payload, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setPendingRecord(response.data)
        })
        .catch((error) => {
          setPendingRecord(null)
          if ((error.response && error.response.status === 403) || !token) {
            // localStorage.removeItem("userData")
            // navigate('/login')
          } else {
            setError('Something Went Wrong')
            setTimeout(() => {
              setError('')
            }, 3000);
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  const getCompletedRecord = async (payload) => {
    // console.log('postUploadFiles', files)
    let token = JSON.parse(localStorage.getItem("userData"))
    if (token) {
      setLoading(true)
      await axios
        .get(`${process.env.REACT_APP_BASE_URL}/gst-profile`, payload, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setCompletedRecord(response.data)
        })
        .catch((error) => {
          setCompletedRecord(null)
          if ((error.response && error.response.status === 403) || !token) {
            // localStorage.removeItem("userData")
            // navigate('/login')
          } else {
            setError('Something Went Wrong')
            setTimeout(() => {
              setError('')
            }, 3000);
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  const getHistoryRecord = async (payload) => {
    // console.log('postUploadFiles', files)
    let token = JSON.parse(localStorage.getItem("userData"))
    if (token) {
      setLoading(true)
      await axios
        .get(`${process.env.REACT_APP_BASE_URL}/gst-profile`, payload, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setHistoryRecord(response.data)
        })
        .catch((error) => {
          setHistoryRecord(null)
          if ((error.response && error.response.status === 403) || !token) {
            // localStorage.removeItem("userData")
            // navigate('/login')
          } else {
            setError('Something Went Wrong')
            setTimeout(() => {
              setError('')
            }, 3000);
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }

  const getReportsRecord = async (payload) => {
    // console.log('postUploadFiles', files)
    let token = JSON.parse(localStorage.getItem("userData"))
    if (token) {
      setLoading(true)
      await axios
        .get(`${process.env.REACT_APP_BASE_URL}/gst-profile`, payload, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        })
        .then(async response => {
          setLoading(false)
          setReportRecord(response.data)
        })
        .catch((error) => {
          setReportRecord(null)
          if ((error.response && error.response.status === 403) || !token) {
            // localStorage.removeItem("userData")
            // navigate('/login')
          } else {
            setError('Something Went Wrong')
            setTimeout(() => {
              setError('')
            }, 3000);
          }
          setLoading(false)
        })
    } else {
      setLoading(false)
    }
  }
  // useEffect(() => {
  //   if (localStorage.getItem("email") && localStorage.getItem("userData")) {
  //     postUploadFiles()
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [])


  const values = {
    uploadFilesResponse,
    pendingRecord,
    completedRecord,
    historyRecord,
    UploadZipFilesResponse,
    reportRecord,
    loading,
    setLoading,
    setPendingRecord,
    setCompletedRecord,
    setHistoryRecord,
    postUploadFiles,
    getPendingRecord,
    getCompletedRecord,
    getHistoryRecord,
    getReportsRecord,
    gstError: error,
    postUserToken,
    postUploadZipFiles,
    postUploadExcelTrueClaim,
    userToken
  }

  return <UploadContext.Provider value={values}>{children}</UploadContext.Provider>
}

export { UploadContext, UploadProvider }
